import { useEffect, useState } from "react";
import { Drawer, withStyles } from "@material-ui/core";
import { RouteComponentProps, useParams } from "react-router-dom";
import {
  ReactAdminComponentProps,
  SimpleForm,
  AutocompleteInput,
  ReferenceInput,
  Create,
  required,
  SelectInput,
} from "react-admin";
import resourceNames from "../../../common/data/resourceNames";
import { CustomResourceRouteParams } from "../../../common/types";
import { EditActions } from "../../common/form/FormActions";
import { useSearchFields } from "../../../common/hooks/useSearchFields";
import { FormToolbar } from "../../common/form/FormToolbar";
import { useAxiosInstance } from "../../../common/hooks/useAxiosInstance";
import {
  UnidentifiedEventsApiFactory,
  VehicleViewApiFactory,
} from "../../../common/data/service-proxies";
import { BulkAssignFormInit } from "./BulkAssignFormInit";
import { useForm } from "react-final-form";
import { allowedUnidentifiedDutyStatusChoices } from "./helpers";

interface Props extends RouteComponentProps<CustomResourceRouteParams> {
  onClose: () => void;
}

type ParamsProps = {
  id: string;
};

const AutocompleteInputInDialog = withStyles({
  suggestionsContainer: { zIndex: 2000 },
})(AutocompleteInput);

export const AssignUnidentifiedDrivingForm = (
  props: Props & ReactAdminComponentProps
) => {
  const { staticContext, ...rest } = props;
  console.log(props, "props");
  const [driverId, setDriverId] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { id } = useParams<ParamsProps>();

  const axios = useAxiosInstance();
  const getVehicleId = async (id: string) => {
    if (!axios) {
      return;
    }

    try {
      setIsLoading(true);
      const response = await UnidentifiedEventsApiFactory(
        undefined,
        axios.defaults.baseURL,
        axios
      ).apiAppUnidentifiedeventsIdGet(Number(id));

      if (response.data && response.data.vehicleId)
        getDriverId(response.data.vehicleId?.toString());
    } catch (error) {
      console.error("Error fetching driver ID:", error);
      setIsLoading(false);
    }
  };

  const getDriverId = async (vehicleId: string) => {
    if (!axios) {
      return;
    }

    try {
      const response = await VehicleViewApiFactory(
        undefined,
        axios.defaults.baseURL,
        axios
      ).apiAppVehicleviewVehiclecurrentdriverVehicleIdGet(Number(vehicleId));

      console.log("API Response:", response);

      if (response.status === 204 || !response.data) {
        console.warn("No driver assigned to this vehicle.");
        return;
      }

      setDriverId(response.data);
    } catch (error) {
      console.error("Error fetching driver ID:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!id) {
      return;
    }
    getVehicleId(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useSearchFields(rest, ["driverName"], resourceNames.ADMIN_DRIVERS);
  return (
    <Drawer
      anchor="right"
      open
      onClose={() => {
        rest.onClose();
      }}
    >
      <Create
        resource={rest.resource}
        basePath={rest.basePath}
        actions={<EditActions />}
        onSuccess={() => {
          rest.onClose();
        }}
        title=" "
      >
        <SimpleForm variant="outlined" toolbar={<FormToolbar />}>
          <SetDriverIdEffect driverId={driverId} />

          <ReferenceInput
            source="driverId"
            label="resources.hos-unidentified-driving.labels.driver"
            reference={resourceNames.ADMIN_DRIVERS}
          >
            <AutocompleteInputInDialog
              optionText="driverName"
              translateChoice={false}
              disabled={isLoading}
            />
          </ReferenceInput>
          <SelectInput
            defaultValue="D"
            source="dutyStatus"
            choices={allowedUnidentifiedDutyStatusChoices}
            validate={required()}
          />
          <BulkAssignFormInit selectedIds={[id]} />
        </SimpleForm>
      </Create>
    </Drawer>
  );
};

const SetDriverIdEffect = ({ driverId }: { driverId: number | null }) => {
  const form = useForm();

  useEffect(() => {
    if (form && driverId !== null) {
      form.change("driverId", driverId);
    }
  }, [driverId, form]);

  return null;
};
